module.exports = __webpack_public_path__ + "assets/a8a107cedeb6e35c67be3888e513c605.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/drop/0/WildStop.mp3
 ** module id = 242
 ** module chunks = 0
 **/